import { memo } from 'react';
import { FAQTopicProps } from './props';
import { Collapse } from '@mui/material';
import styles from './styles.module.scss';
import { useToggle } from '@starsoft/common/hooks';
import useAffiliatesFAQTopic from '@/hooks/theme/variants/Affiliates/useAffiliatesFAQTopic';
import FaqTopicIcon from './Icon';

function FAQTopic({ title, description }: FAQTopicProps) {
  const { isV2Version } = useAffiliatesFAQTopic();

  const [isOpen, toggle] = useToggle();

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__uncollapsed} ${isV2Version ? styles['container__uncollapsed--V2'] : ''}`}
        onClick={toggle}
      >
        <div
          className={`${styles.container__row} ${isV2Version ? styles['container__row--V2'] : ''}`}
        >
          <FaqTopicIcon isOpen={isOpen} />
          <h6 className={styles.container__title}>{title}</h6>
        </div>

        <i
          className={`${styles.container__chevron} ${isOpen ? styles['container__chevron--open'] : ''} fa-solid fa-chevron-down`}
        />
      </div>

      <Collapse in={isOpen}>
        <div className={styles.container__collapsed}>
          <p className={styles.container__description}>{description}</p>
        </div>
      </Collapse>
    </div>
  );
}

export default memo(FAQTopic);
